<template>
    <Dashboard
        :title="__('Settings')"
    >
        <Heading
            :label="__('Profile', null, $page.props.profile_locale)"
        />

        <form
            @submit.prevent="updateUser"
            class="grid md:grid-cols-3 grid-cols-1 gap-3 mb-3"
        >
            <InputLabel id="first_name" :label="__('First name', null, $page.props.profile_locale)" v-model="user.first_name" autocomplete="first_name" />
            <InputLabel id="last_name" :label="__('Last name', null, $page.props.profile_locale)" v-model="user.last_name" autocomplete="last_name" />

            <div class="grid grid-cols-6 col-start-1 col-span-full gap-3">
                <InputLabel
                    id="street"
                    :label="__('Street', null, $page.props.profile_locale)"
                    v-model="user.street"
                    class="col-span-3"
                    autocomplete="street"
                />
                <InputLabel
                    id="building"
                    :label="__('Building', null, $page.props.profile_locale)"
                    v-model="user.building"
                    class="col-span-2"
                    autocomplete="building"
                />
                <InputLabel
                    id="flat"
                    :label="__('Flat', null, $page.props.profile_locale)"
                    v-model="user.flat"
                    class="col-span-1"
                    autocomplete="flat"
                />
            </div>

            <InputLabel
                id="zip"
                :label="__('Zip', null, $page.props.profile_locale)"
                v-model="user.zip"
                autocomplete="zip"
            />
            <InputLabel
                id="city"
                :label="__('City', null, $page.props.profile_locale)"
                v-model="user.city"
                autocomplete="city"
            />

            <Select
                class="col-start-1"
                :label="__('Country', null, $page.props.profile_locale) + ' *'"
                v-model="user.country"
                :data="countries"
                id="billing.country"
            >
                <template #display="props">
                    <div class="flex items-center">
                        {{ __('countries.' + props.value) }}
                        <img class="mx-1 w-6 h-6 max-w-max" :src="getLangImage(props.value)">
                    </div>
                </template>
                <template #default="props">
                    <Option
                        v-for="(item, key) in props.data"
                        :key="key"
                        @click="props.clicked(key)"
                        class="flex justify-between"
                        color="yellow"
                        :selected="props.active == key"
                    >
                        {{ __('countries.' + key) }}
                        <img class="mx-1 w-6 h-6 max-w-max" :src="getLangImage(key)">
                    </Option>
                </template>
            </Select>

            <InputLabel
                id="user.email"
                class="col-start-1"
                :label="__('Email', null, $page.props.profile_locale)"
                v-model="user.email"
                autocomplete="email"
            />

            <InputLabel
                id="phone"
                :label="__('Phone', null, $page.props.profile_locale)"
                v-model="user.phone"
                autocomplete="phone"
            />
             <div class="col-start-1">
                <BreezeButton class=" py-2 px-4"
                    :loading="loading.status"
                >
                    {{__('Save', null, $page.props.profile_locale)}}
                </BreezeButton>
            </div>
        </form>
        <Heading
            :label="__('Settings', null, $page.props.profile_locale)"
            class="mt-5"
            v-if="$page.props.auth.user.id == user.id"
        />
        <form
            @submit.prevent="changePassword"
            class="grid grid-cols-2 gap-3"
            v-if="$page.props.auth.user.id == user.id || $page.props.auth.user.type != 'admin'"
        >
            <InputLabel
                :label="__('Current Password', null, $page.props.profile_locale)"
                id="old_password"
                type="password"
                class="col-span-2"
                v-model="form.old_password"
                autocomplete="old_password"
            />
            <InputLabel
                :label="__('Password', null, $page.props.profile_locale)"
                id="password"
                type="password"
                class="mt-1 block"
                v-model="form.password"
                autocomplete="password"
            />
            <InputLabel
                :label="__('Confirm Password', null, $page.props.profile_locale)"
                id="password_repeat"
                type="password"
                class="mt-1 block"
                v-model="form.password_repeat"
                autocomplete="password_repeat"
            />

            <div class="flex">
                <BreezeButton class="py-2 px-4"
                    @click.prevent="changePassword"
                >
                    {{__('Update', null, $page.props.profile_locale)}}
                </BreezeButton>
            </div>
        </form>

        <div class="grid md:grid-cols-3 gap-3 mt-5" v-if="isAdmin($page.props.auth.user) && $page.props.auth.user.id == user.id">
            <Select
                :label="__('Language in the admin panel', null, $page.props.profile_locale)"
                v-model="user.locale"
                :data="$page.props.languages"
                id="billing.country"
            >
                <template #display="props">
                    <div class="flex items-center">
                        {{ __(props.data[props.value], null, $page.props.profile_locale) }}
                        <img class="mx-1 w-6 h-6 max-w-max" :src="getLangImage(props.value)">
                    </div>
                </template>
                <template #default="props">
                    <Option
                        v-for="(item, key) in props.data"
                        :key="key"
                        @click="props.clicked(key)"
                        class="flex justify-between"
                        color="yellow"
                        :selected="props.active == key"
                    >
                        {{ __(item, null, $page.props.profile_locale) }}
                        <img class="mx-1 w-6 h-6 max-w-max" :src="getLangImage(key)">
                    </Option>
                </template>
            </Select>
            <Checkbox
                v-if="$page.props.auth.user.type == 'admin'"
                :label="__('Construction mode', null, $page.props.profile_locale) + ' (Admin)'"
                id="construction"
                v-model="mode"
                class="border-t mt-5 pt-5 col-start-1 col-span-full"
            />
            <div class="flex">
                <BreezeButton class="py-2 px-4"
                    @click.prevent="constructionModel"
                >
                    {{__('Update', null, $page.props.profile_locale)}}
                </BreezeButton>
            </div>
        </div>

        <Heading
                :label="__('Remove account', null, $page.props.profile_locale)"
                class="mt-5"
            />
            <div class="flex">
                <BreezeButton class="py-2 px-4"
                    color="red"
                    @click="removeAccount"
                >
                    {{__('Remove', null, $page.props.profile_locale)}}
                </BreezeButton>
            </div>
    </Dashboard>
</template>

<script>
    import Dashboard from '@/Layouts/Dashboard';
    import BreezeButton from 'UI/Button';
    import InputLabel from 'UI/InputLabel';
    import Heading from 'COMP/Heading';
    import { Inertia } from '@inertiajs/inertia'
    import { useForm, usePage } from '@inertiajs/inertia-vue3';

    import Select from 'COMP/CustomSelect/Select';
    import Option from 'COMP/CustomSelect/Option';
    import Checkbox from 'UI/Checkbox';

    import {
        getLangImage,
        isAdmin
    } from 'helper';
    import { ref, watch } from '@vue/runtime-core';

    export default {
        components: {
            Dashboard, BreezeButton, InputLabel, Heading, Select, Option, Checkbox
        },
        props: ['profile', 'construction', 'countries'],
        setup(props) {
            const form = useForm({
                old_password: '',
                password: '',
                password_repeat: '',
            })
            const user = ref(props.profile);


            if(!user.value.locale) user.value.locale = usePage().props.value.locale;

            function changePassword() {
                form.post("/change/password", {
                    preserveScroll: true,
                    onSuccess: (e) => { form.reset() },
                })
            }

            watch(() => user.value.locale, (val) => {
                if(isAdmin(user.value)){
                     Inertia.post(route('update.user'), { locale: val }, {
                        preserveScroll: true,
                    })
                }
            })

            const mode = ref(props.construction);
            const loading = ref({
                mode: null,
                status: false,
            })

            const removeAccount = () => {
                if(
                    confirm(
                        app.__('Are you sure you want to delete your account?',null, usePage().props.value.profile_locale)
                    )
                ) {
                    Inertia.post(route('user.remove', user.value.id), {}, {
                        preserveScroll: true,
                    })
                }
            }

            return {
                removeAccount,
                changePassword,

                getLangImage,
                isAdmin,

                form,
                user,
                mode,
                loading,
            }
        },
        methods: {
            updateUser() {
                this.loading.status = true;
                let _this = this;
                Inertia.post(route('update.user'), {
                    user: _this.user,
                    admin: isAdmin(this.$page.props.auth.user),
                }, {
                    preserveScroll: true,
                    onSuccess: function(){
                        _this.loading.status = false;
                    },
                })
            },
            constructionModel() {
                Inertia.post(route('construction.mode'), {
                    mode: this.mode,
                }, {
                    preserveScroll: true,
                })
            }
        }

    }
</script>
